module.exports = __webpack_public_path__ + "static/media/zookeeper.d389fc97.jpg";